var map = {
	"./Beige.png": 6988,
	"./Black.png": 2381,
	"./Blue.png": 6030,
	"./Brown.png": 6204,
	"./Crash Test.png": 6437,
	"./Dark Brown.png": 98,
	"./Frost.png": 2270,
	"./Grey Wolf.png": 6695,
	"./Pine Tree.png": 6634,
	"./Pink.png": 602,
	"./Purple.png": 4368,
	"./Snow Leopard.png": 8248,
	"./Tibetan Fox.png": 244,
	"./White.png": 8759,
	"./Wolverine.png": 9273,
	"./X-Ray.png": 7067
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2325;